<template>
  <div class="nmz_flash_swiper" @touchstart="touchstart" @touchmove="touchmove">
    <slick :class="slickClass" ref="slick" :style="slickWrapStyle" :options="slick_options">
      <div
        v-for="(item, index) in data_list"
        class="swipe_item"
        :dataIndex="index"
        :key="index"
        :style="imgStyle"
      >
        <img :style="imgStyle" class="img_content" :src="item.img"  />

        <!-- m03有title icon -->
        <template v-if="show_type === 'm03' || show_type === 'm04'|| show_type === 'm06'">
          <div class="fall"></div>
          <div class="title_wrap">
            <div class="title">{{item.title}}</div>
            <div class="icon">
              <CoverIcon :info="item.icon" size="large" />
            </div>
          </div>
          <div class="sub_title">{{item.sub_title}}</div>
        </template>
      </div>
    </slick>
  </div>
</template>
<script>
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css"; //if dots
import { getJSON, getJSONP } from "../../../api/myaxios";
import { openLink } from "../../../tools/mgtv/link";
import click_handler from "../../../tools/mgtv/click";
import { toRem, urlToWebp } from "../../../tools/tpl";
import handle_action from "../../../tools/mgtv/action";
import CoverIcon from "../CoverIcon";

const slick_config = {
  m01: {
    //福利社头部
    wrapStyle: {
      width: "7.5rem",
      height: "2rem"
    },
    imgStyle: {
      width: "7rem",
      height: "2rem",
      margin: "0 .02rem"
    },
    slick_option: {
      slidesToShow: 1,
      centerMode: true, //centerMode=true 和 centerPadding一起设置为可以看到其他的卡片
      centerPadding: ".22rem"
    }
  },
  m03: {
    //会员频道头部
    wrapStyle: {
      marginLeft: ".2rem",
      width: "7.1rem",
      height: "4rem"
    },
    imgStyle: {
      width: "7.1rem",
      height: "4rem"
    },
    slick_option: {
      dots: true
    }
  },
  m02: {
    //福利社滚动福利
    wrapStyle: {
      width: "7.1rem",
      height: "1.6rem",
      marginLeft: ".2rem"
    },
    imgStyle: {
      width: "3.4rem",
      height: "1.6rem"
    },
    slick_option: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  },
  m04: {
    //750x422 样式
    wrapStyle: {
      width: "7.5rem",
      height: "4.22rem"
    },
    imgStyle: {
      width: "7.5rem",
      height: "4.22rem"
    },
    slick_option: {
      dots: true
    }
  },
  m05: {
    //230x321 竖型海报， 每屏幕显示3个,
    wrapStyle: {
      width: "7.5rem",
      height: "3.21rem"
    },
    imgStyle: {
      width: "2.3rem",
      height: "3.21rem"
      // margin: "0.02rem"
    },
    slick_option: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  },
  m06: {
    //750x750 沉浸式海报
    wrapStyle: {
      width: "7.5rem",
      height: "7.5rem"
    },
    imgStyle: {
      width: "7.5rem",
      height: "7.5rem"
    },
    slick_option: {
      dots: true
    }
  }
};

const default_slick_option = {
  slidesToShow: 1,
  centerMode: false,
  infinite: true,
  mobileFirst: true,
  adaptiveHeight: false,
  centerPadding: 0,
  autoplay: false,
  autoplaySpeed: 3000,
  dots: false,
  arrows: false,
  speed:200
};

export default {
  name: "Swiper",
  components: {
    Slick,
    CoverIcon
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    },
    data_list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  touchStartX: 0,
  touchStartY:0,
  methods: {
    click_item(item) {
      click_handler(
        `${this.info.act_name_chn}-点击-${item.id}`,
        () => {
          handle_action(item);
        },
        {
          need_act: item.action_info.need_act,
          need_login: item.action_info.need_login,
          need_new_user: item.action_info.need_new_user
        }
      );
    },
    touchstart(e) {
      if (gact.is_ios_app) {
        // console.log("touchstart", e, e.touches[0].pageX);
        this.touchStartX = e.touches[0].pageX;
        this.touchStartY = e.touches[0].pageY;
      }
    },
    touchmove(e) {
      if (gact.is_ios_app) {
        /**
         * IOS APP中 频道页左右滑动时切换频道,preventDefault之后不会将事件传给webview，我们将左右滑动幅度大的事件屏蔽掉。如果一律屏蔽，会导致上下滑动也被禁止了。
         */
        const pageX = e.touches[0].pageX;
        const pageY = e.touches[0].pageY;
        //水平移动距离>纵向移动距离 判定为横向移动
        const isMoveHorizontal = Math.abs(pageX - this.touchStartX) > Math.abs(pageY - this.touchStartY)
        // console.log("touchmove", isMoveHorizontal);
        if (isMoveHorizontal) {
          // console.log("prevent move");
          e.preventDefault && e.preventDefault();
          e.returnValue = false;
          e.stopPropagation && e.stopPropagation();
          // console.log('return false')
          return false;
        }
        // console.log('return true')
      }
    },
    // imgLoad(e, src){
    //   if(window.apmInst){
    //     const useTime = this.createdTime  > 0 ?new Date().getTime() - this.createdTime  : 0
    //     let mode = 'origin'
    //     if(src.startsWith('mgwebp')){
    //       mode = 'mgwebp'
    //     }else if(src.endsWith('webp')){
    //       mode = 'webp'
    //     }
    //     window.apmInst.event('webpABTest',{src,  mode, useTime})
    //   }
    // }
  },
  mounted() {
    setTimeout(() => {
      // this.$refs.slick.reSlick();
      const doms = this.$el.querySelectorAll(".swipe_item");
      if (!doms) {
        return;
      }
      [...doms].forEach(domItem => {
        const dataItem = this.data_list[
          parseInt(domItem.getAttribute("dataIndex"))
        ];
        domItem.addEventListener("click", () => {
          this.click_item(dataItem);
        });
      });
    }, 200);
  },
  computed: {
    show_type: function() {
      return this.info.config.show_type || "m01";
    },
    sconfig: function() {
      return slick_config[this.show_type];
    },
    slick_options() {
      return Object.assign(
        {},
        default_slick_option,
        this.sconfig.slick_option,
        {
          autoplay: this.info.config.autoplay
        }
      );
    },
    slickClass() {
      return "slick_wrap skick_wrap_" + this.show_type;
    },
    slickWrapStyle() {
      return this.sconfig.wrapStyle;
    },
    imgStyle() {
      return this.sconfig.imgStyle;
    }
  },
  created(){
    this.createdTime = new Date().getTime()
  }
};
</script>


<style lang="stylus"  >
  @import "../../../share/mixins.styl"
  .nmz_flash_swiper
    position relative
    width 7.5rem
    .bottom
      position absolute
      bottom 0
    .slick_wrap
      width 7.5rem
      position relative

    .swipe_item
      position relative
      .img_content
        display block
        width 100%
        height 100%
        border-radius 0.05rem
        margin 0 auto

    .slick-dots
      position absolute
      bottom .2rem
      display flex
      right .2rem
      li
        width .2rem
        display flex
        justify-content center
      button
        display block
        font-size 0
        width 0.1rem
        height 0.1rem
        display block
        background white
        opacity 0.5
        border-radius 0.05rem
        outline none
        border none
        transition width 0.2s
      .slick-active
        button
          opacity 1
          width .2rem

    .skick_wrap_m03
    .skick_wrap_m04
    .skick_wrap_m06
      .fall
        position absolute
        bottom 0
        height 1.3rem
        width 100%
        background: linear-gradient(to bottom, rgba(1,1,1,0) 0%, rgba(1,1,1,0.5) 100%);

      .title_wrap
        position absolute
        bottom .56rem
        left .16rem
        display flex
        align-items center
        width 100%
        .title
          white-space nowrap
          font-size .38rem
          color #FFFFFF
          ellipsis()
          max-width 80%
          font-weight bold
          @media screen and (min-width: 700px)
            font-size 20PX
        .icon
          margin-left .1rem
      .sub_title
        position absolute
        font-size .22rem
        bottom .2rem
        left .34rem
        color #FFFFFF
        white-space nowrap
        //padding-left .15rem
        ellipsis()
        max-width 90%
        font-weight bold
        @media screen and (min-width: 700px)
          font-size 14PX

</style>
